"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKELETON_MAIN_CATEGORY_MOBILE = exports.SKELETON_CATALOGUE_MOBILE = void 0;
const SKELETON_CATALOGUE_MOBILE = exports.SKELETON_CATALOGUE_MOBILE = 'skeleton-catalogue-mobile';
const SKELETON_MAIN_CATEGORY_MOBILE = exports.SKELETON_MAIN_CATEGORY_MOBILE = 'skeleton-main-category-mobile';
